import classNames from "classnames";
import { NavLink } from "react-router-dom";
import logo from "../images/RSG-logos-3.png";

const Navbar = () => {
  return (
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="navigation w-nav"
    >
      <div className="navigation-items">
        <a
          href="/"
          aria-current="page"
          className="logo-link w-nav-brand w--current"
        >
          <img
            src={logo}
            width="325"
            sizes="(max-width: 479px) 100vw, 325px"
            alt="logo"
            className="logo-image"
          />
        </a>
        <div className="navigation-wrap">
          <nav role="navigation" className="navigation-items w-nav-menu">
            <NavLink
              aria-current="page"
              to="/"
              className={({ isActive }) =>
                classNames(
                  "navigation-item w-nav-link",
                  isActive && "w--current"
                )
              }
            >
              Home
            </NavLink>
            <NavLink
              aria-current="page"
              to="/about"
              className={({ isActive }) =>
                classNames(
                  "navigation-item w-nav-link",
                  isActive && "w--current"
                )
              }
            >
              About
            </NavLink>
            {/* <NavLink
              aria-current="page"
              to="/interest-selection"
              className={({ isActive }) =>
                classNames(
                  "navigation-item w-nav-link",
                  isActive && "w--current"
                )
              }
            >
              Beign Study
            </NavLink> */}
          </nav>
          <div className="menu-button w-nav-button">
            <img
              src="images/menu-icon_1menu-icon.png"
              width="22"
              alt=""
              className="menu-icon"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
